// extracted by mini-css-extract-plugin
export default {"loading":"CcpaDeleteModal_loading__nlcwf","footer":"CcpaDeleteModal_footer__5kh9F"};